import Chart from 'chart.js'
import { Line } from 'vue-chartjs'
import { interpolateRainbow } from 'd3-scale-chromatic'

export default {
  props: ['items'],
  extends: Line,
  watch: {
    items () {
      const datasets = this.$data._chart.data.datasets
      let maxQuantity = 0
      if (this.items.length > 0) {
        for (let i = datasets.length; i < this.items.length; i++) {
          const item = this.items[i]
          datasets[i] = {
            label: `${item.sku} (${item.supplier.name})`,
            fill: false,
            data: item.update.prices.length > 0 ? item.update.prices.map(pricing => {
              if (pricing.quantity > maxQuantity) {
                maxQuantity = pricing.quantity
              }
              return { x: pricing.quantity, y: pricing.price * item.supplier.exchangeRate }
            }) : [],
            steppedLine: 'before'
          }
        }
        datasets.forEach((dataset, index) => {
          dataset.backgroundColor = interpolateRainbow(index / this.items.length)
          dataset.borderColor = interpolateRainbow(index / this.items.length)
          if (dataset.data.length > 0 && maxQuantity > dataset.data[dataset.data.length - 1].x) {
            dataset.data.push({
              x: maxQuantity,
              y: dataset.data[dataset.data.length - 1].y
            })
          }
        })
      } else {
        this.$data._chart.data.datasets = []
      }
      this.$data._chart.update()
    }
  },
  mounted () {
    this.renderChart(
      {
        datasets: []
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'logarithmic',
            position: 'bottom',
            ticks: {
              userCallback: tick => {
                const remain = tick / (Math.pow(10, Math.floor(Chart.helpers.log10(tick))))
                if (remain === 1 || remain === 2 || remain === 5) {
                  return tick.toString()
                }
                return ''
              }
            }
          }],
          yAxes: [{
            type: 'linear'
          }]
        }
      }
    )
  }
}
